module.exports = __webpack_public_path__ + "static/flags/DA-a55daa3d32023ed3763050386fe332fd.gif";